import { RadioButtonField } from '@epages/react-components'
import { useSelector } from 'react-redux'
import cc from 'classcat'

import { useTranslate } from '../../../../../utils/translate'
import FormGroup from '../../../../formComponents/FormGroup'
import ImageField from '../image/ImageField'
import InputField from '../../../../formComponents/InputField'

type ImageSettingsProps = {
  config: {
    storeFile: (file: File) => Promise<any>
    imageUrl?: (url: string) => string
    previewUrl?: (url: string) => string
  }
  handleError: ({ error }: { error: any }) => any
  imageInfo?: {
    isSlider: boolean
    src: string
  }
}

export default function ImageSettings({ config, handleError, imageInfo }: Readonly<ImageSettingsProps>) {
  const recommendedImageDimensions = useSelector<State, ImmutableMap>((state) =>
    state.getIn(['themeMeta', 'recommendedImageDimensions']),
  )

  const isSlider = Boolean(imageInfo?.isSlider)
  const componentName = isSlider ? 'contentSliderComponent' : 'imageElementComponent'
  const isDisabled = !imageInfo?.src

  const t = useTranslate('interface', `components.${componentName}.settingsModal`)

  const recommendedImageWidth = isSlider ? recommendedImageDimensions.get('imageSlider').get(0) : null

  const recommendedImageHeight = isSlider ? recommendedImageDimensions.get('imageSlider').get(1) : null

  const imageAlignmentRadioButtons = isSlider && [
    {
      label: t('imageAlignment.options.top'),
      value: 'top',
    },
    {
      label: t('imageAlignment.options.bottom'),
      value: 'bottom',
    },
    {
      label: t('imageAlignment.options.center'),
      value: 'center',
    },
  ]

  const renderAlignment = () => {
    if (imageAlignmentRadioButtons) {
      return (
        <FormGroup name="alignment" label={t('imageAlignment.label')} className={cc([{ disabled: isDisabled }])}>
          <RadioButtonField
            className="dali-settingslayer-contentslider-image-alignment"
            name="alignment"
            buttons={imageAlignmentRadioButtons}
            disabled={isDisabled} // emptyPredicate
          />
        </FormGroup>
      )
    }

    return null
  }

  return (
    <>
      {isSlider && (
        <>
          <div className="ep-form-row">
            <div className="dali-settingslayer-element">
              <div className="dali-settingslayer-hint">
                {t('imageInfo', { recommendedImageWidth, recommendedImageHeight })}
              </div>
            </div>
          </div>
          <div className="ep-form-row">
            <ImageField
              name="imageData"
              storeFile={config.storeFile}
              imageUrl={config.imageUrl}
              previewUrl={config.previewUrl}
              onError={(error) => handleError({ error })}
              onChange={() => handleError({ error: null }) || true}
              showDeleteButton={isSlider}
              className={cc([{ 'dali-settingslayer-element': isSlider }])}
            />
          </div>
        </>
      )}
      {renderAlignment()}
      <FormGroup
        info={t('alternativeTextInputField.explanation')}
        name="alt"
        tagName="label"
        label={t('alternativeTextInputField.label')}
        className={cc([{ disabled: isDisabled }])}
        disabled={isDisabled}
      >
        <InputField autoFocus name="alt" type="text" disabled={isDisabled} />
      </FormGroup>
    </>
  )
}
